
function checkClick(event: any) {
  const target = event.currentTarget || event.target as any;
  const after = getComputedStyle(target, ":before");

  if (after) {
    // Then we parse out the dimensions
    const atop = Number(after.getPropertyValue("top").slice(0, -2));
    const aheight = Number(after.getPropertyValue("height").slice(0, -2));
    const aleft = Number(after.getPropertyValue("left").slice(0, -2));
    const awidth = Number(after.getPropertyValue("width").slice(0, -2));

    // And get the mouse position
    const ex = event.layerX || event.offsetX || event.clientX;
    const ey = event.layerY || event.offsetY || event.clientY;

    // Finally we do a bounds check (Is the mouse inside of the after element)
    if (ex > aleft && ex < aleft + awidth && ey > atop && ey < atop + aheight) {
      return true;
    }
  }

  return false;
}

export default checkClick;
